<script setup lang="ts">
import { computed } from 'vue';
import { VIEW_HISTORY_ON } from '@vp/render';
import { live, ui } from '../editor/bridge';
import { settings } from '../platform';
import { t } from '../i18n';
import Icon from './Icon.vue';

/** Zoom and "fit all" (§4.3). Previous/next view is OFF (`VIEW_HISTORY_ON`). */
const label = computed(() => {
  const z = ui.zoom * 100;
  return (z < 1 ? z.toPrecision(2) : z < 10 ? z.toFixed(1) : Math.round(z).toString()) + '%';
});
</script>

<template>
  <div class="float pillbar zoom glass" role="group" :aria-label="t('cmd.zoomReset')" @mousedown.prevent>
    <button class="icon-btn" :aria-label="t('cmd.zoomOut')" :title="t('cmd.zoomOut')" @click="live.editor?.zoomBy(0.8)"><Icon name="minus" /></button>
    <button class="pct" :title="t('cmd.zoomReset')" :aria-label="t('cmd.zoomReset') + ': ' + label" @click="live.editor?.zoomTo(1)">{{ label }}</button>
    <button class="icon-btn" :aria-label="t('cmd.zoomIn')" :title="t('cmd.zoomIn')" @click="live.editor?.zoomBy(1.25)"><Icon name="plus" /></button>
    <!-- OFF: previous / next view (`VIEW_HISTORY_ON`) -->
    <template v-if="VIEW_HISTORY_ON">
      <span class="sep"></span>
      <button class="icon-btn" :disabled="!ui.canViewBack" :aria-label="t('keys.viewBack')" :title="t('keys.viewBack')" @click="live.editor?.backView()"><Icon name="chevronLeft" /></button>
      <button class="icon-btn" :disabled="!ui.canViewForward" :aria-label="t('keys.viewForward')" :title="t('keys.viewForward')" @click="live.editor?.forwardView()"><Icon name="chevron" /></button>
    </template>
    <span class="sep"></span>
    <button class="icon-btn" :class="{ active: ui.bookmarksOpen }" :aria-pressed="ui.bookmarksOpen" :aria-label="t('bookmarks.title')" :title="t('bookmarks.title')" data-act="bookmarks" @click="ui.bookmarksOpen = !ui.bookmarksOpen"><Icon name="bookmark" /></button>
    <button class="icon-btn" :class="{ active: settings.minimap }" :aria-pressed="settings.minimap" :aria-label="t('minimap.title')" :title="t('minimap.title')" @click="settings.minimap = !settings.minimap"><Icon name="map" /></button>
    <button class="icon-btn" :aria-label="t('cmd.fitAll')" :title="t('cmd.fitAll')" @click="live.editor?.fitAll()"><Icon name="fit" /></button>
  </div>
</template>

<style scoped>
.zoom {
  right: 12px;
  bottom: 12px;
}
.pct {
  min-width: 58px;
  height: 30px;
  border: none;
  background: none;
  border-radius: var(--radius-control);
  cursor: pointer;
  font-variant-numeric: tabular-nums;
}
.pct:hover {
  background: var(--hover);
}
</style>
